import React from 'react'
import { format } from 'date-fns'

interface DateInputProps {
  value: Date | null
  onChange: (date: Date | null) => void
  placeholder?: string
  className?: string
}

const DateInput: React.FC<DateInputProps> = ({
  value,
  onChange,
  placeholder = 'MM / DD / YYYY',
  className = '',
}) => {
  const displayValue = value ? format(value, 'MM / dd / yyyy') : ''

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value
    // Parse MM / DD / YYYY format
    const parts = inputValue.split('/').map(p => p.trim())
    if (parts.length === 3) {
      const month = parseInt(parts[0])
      const day = parseInt(parts[1])
      const year = parseInt(parts[2])
      
      if (!isNaN(month) && !isNaN(day) && !isNaN(year)) {
        const date = new Date(year, month - 1, day)
        if (!isNaN(date.getTime())) {
          onChange(date)
        }
      }
    }
  }

  return (
    <input
      type="text"
      value={displayValue}
      onChange={handleInputChange}
      placeholder={placeholder}
      className={`
        w-full px-3 py-2 text-sm border border-gray-300 rounded-lg
        focus:outline-none focus:ring-2 focus:ring-flutter-button focus:border-flutter-button
        font-['IBM Plex Sans Arabic']
        ${className}
      `}
    />
  )
}

export default DateInput

